import { useItemInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemInfo";
import SimpleArticleCardSkeleton from "@coworker/apprestructured/src/shared/simple/SimpleSkeleton/SimpleArticleCardSkeleton";
import { CustomTestbuyAddItemCard } from "@coworker/apprestructured/src/testbuy/components/CustomTestbuyAddItemCard/CustomTestbuyAddItemCard";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import styles from "./custom-testbuy-items-list-view-item.module.css";

interface CustomTestbuyItemsListViewItemProps {
  itemNo: string;
  homeLocationGridCode: string;
}

export const CustomTestbuyItemsListViewItem = ({
  itemNo,
  homeLocationGridCode,
}: CustomTestbuyItemsListViewItemProps) => {
  const { data: itemInfo, isLoading: isLoadingItemInfo } = useItemInfo(itemNo);

  return (
    <div>
      {isLoadingItemInfo && <SimpleArticleCardSkeleton />}
      {!isLoadingItemInfo && itemInfo && (
        <FixaListViewItem
          className={styles["custom-testbuy-list-root"] || ""}
          size="medium"
          title={
            <CustomTestbuyAddItemCard
              item={itemInfo}
              homeLocationGridCode={homeLocationGridCode}
            />
          }
          inset
        />
      )}
    </div>
  );
};
